export * from './section-with-image-v2'
